import { defineStore } from 'pinia'
import axios from 'axios'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    isAdmin: false,
    accessToken: null,
    userId: null,
  }),
  actions: {
    async login(formData) {
      try {
        const response = await axios.post('/api/token', formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        this.user = response.data.sub
        this.isAdmin = response.data.is_admin
        this.accessToken = response.data.access_token
        this.userId = response.data.user_id
        this.setAxiosAuthHeader()
        return true
      } catch (error) {
        console.error('Login failed', error)
        return false
      }
    },
    logout() {
      this.user = null
      this.isAdmin = false
      this.accessToken = null
      this.userId = null
      this.removeAxiosAuthHeader()
    },
    setAxiosAuthHeader() {
      axios.defaults.headers.common['Authorization'] = `Bearer ${this.accessToken}`
    },
    removeAxiosAuthHeader() {
      delete axios.defaults.headers.common['Authorization']
    }
  },
})